import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Optimizer from './pages/Optimizer';
import ProfileOptimizer from './pages/ProfileOptimizer';
import BaseResume from './pages/BaseResume';
import Tracker from './pages/Tracker';
import JobAlerts from './pages/JobAlerts';
import PeerReview from './pages/PeerReview';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import { ProfileProvider } from './context/ProfileContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Auth from './pages/Auth';
import './index.css';

const ProtectedRoute = ({ children }) => {
  const { session } = useAuth();
  if (!session) {
    return <Navigate to="/auth" replace />;
  }
  return children;
};

function AppRoutes() {
  const { session } = useAuth();

  return (
    <Routes>
      <Route path="/auth" element={session ? <Navigate to="/" replace /> : <Auth />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="optimizer" element={<Optimizer />} />
        <Route path="profile-optimizer" element={<ProfileOptimizer />} />
        <Route path="base-resume" element={<BaseResume />} />
        <Route path="tracker" element={<Tracker />} />
        <Route path="alerts" element={<JobAlerts />} />
        <Route path="community" element={<PeerReview />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;